export default "__VITE_ASSET__BaHrt5Ce__"